import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';

class App extends Component {
  state = {}

  render () {
    return (
      <AppRoutes />
    );
  }

}

export default withRouter(App);
